import React from 'react';
import Icon from '@/components/Icon';
import { mdiMicrophoneOff, mdiMicrophone, mdiAlertCircle } from '@mdi/js';
import styles from './AudioDevicesIndicator.module.css';

export type AudioDevicesIndicatorProps = {
    warning: string | null;
    canHandleCalls: boolean;
    onClick?: () => void;
};

/**
 * Indicador visual do status de dispositivos de áudio
 * Mostra um ícone de alerta se o usuário não pode atender chamadas
 */
export const AudioDevicesIndicator: React.FC<AudioDevicesIndicatorProps> = ({
    warning,
    canHandleCalls,
    onClick,
}) => {
    if (canHandleCalls && !warning) {
        return null
    }

    return (
        <div
            className={`${styles.indicator} ${styles.warning}`}
            title={warning || 'Não é possível atender chamadas de voz'}
            onClick={onClick}
            role="button"
            tabIndex={0}
        >
            <Icon path={mdiMicrophoneOff} size={1.5} />
            <Icon path={mdiAlertCircle} size={0.5} className={styles.alertBadge} />
        </div>
    );
};

export default AudioDevicesIndicator;
